import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { handleError } from 'api';
import {
  CreateUserDTO,
  UserApiService,
} from 'features/users/api/user-api.service';

const { unassginedEventAccess } = UserApiService();

export const useEventAccessUpdateAgentRole = () => {

  return useMutation(
    (payload: CreateUserDTO) => {
      return unassginedEventAccess(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
     
    },
  );
};





